<template>
  <div>

    <!-- visualarea -->
    <!--<section id="visualarea" tabindex="0">-->
      <!--<div class="grab">-->
        <!--<div class="area">-->
          <!--<div class="areabg">-->
            <!--<div class="txt" id="area_0" style="opacity: 0; display: none;">-->
              <!--<strong>{{ $t("home_slide_1_title") }}</strong>-->
              <!--<p>{{ $t("home_slide_1_content") }}</p>-->
              <!--<a v-on:click="goPage('centerpurpose')">{{ $t("home_slide_more") }}</a>-->
            <!--</div>-->
            <!--<div class="txt" id="area_1" style="opacity: 1; display: block;">-->
              <!--<strong>{{ $t("home_slide_2_title") }}</strong>-->
              <!--<p>{{ $t("home_slide_2_content") }}</p>-->
              <!--<a v-on:click="goPage('datasystem')">{{ $t("home_slide_more") }}</a>-->
            <!--</div>-->
          <!--</div>-->

          <!--<div class="control_area">-->
            <!--<div class="control control_shape">-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div id="visual">-->
        <!--&lt;!&ndash;<div id="area_0"></div>&ndash;&gt;-->
        <!--&lt;!&ndash;<div id="area_1"></div>&ndash;&gt;-->
      <!--</div>-->
    <!--</section>-->
    <!-- //visualarea -->

    <main-slider></main-slider>

    <!-- container -->
    <section id="container" class="container">

      <!-- content -->
      <div class="mcontent">

        <!-- rcae 홍보 -->
        <div class="publicity">
          <!-- <h3><a href="/kor/publication/pageView/115" title="홍보 바로가기"><em>KASI</em>홍보</a></h3> -->
          <div class="area">
            <div class="obj publication">
              <ul>
                <!--연구분야-->
                <li class="notice">
                  <div class="pbox">
                    <strong>
                      <a v-on:click="goPage('researchfield' , {tabIndex: 0})">
                        <h3>{{ $t("researchfield_title_1") }}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <span>
											<ul class="ul_list_line study">
													<li v-for="performtitle in perform1">{{$t(performtitle.title)}}</li>
											</ul>
										</span>
                  </div>
                </li>
                <li class="notice">
                  <div class="pbox">
                    <strong>
                      <a v-on:click="goPage('researchfield', {tabIndex: 1})">
                        <h3>{{ $t("researchfield_title_2") }}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <span>
											<ul class="ul_list_line study">
                        	<li v-for="performtitle in perform2">{{$t(performtitle.title)}}</li>
											</ul>
										</span>
                  </div>
                </li>
                <li class="notice li-image">
                  <div class="pbox imagebox image01">
                    <strong>
                      <a v-on:click="goPage('datasystem')">
                        <h3>{{ $t("datasystem") }}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <p>
                      {{ $t("home_datasystem_content") }}
                    </p>
                  </div>
                </li>


                <li class="notice li-image">
                  <div class="pbox imagebox image02">
                    <strong>
                      <a v-on:click="goPage('centerperson')">
                        <h3>{{$t("home_person_title")}}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <p>
                      {{ $t("home_person_content") }}
                    </p>
                  </div>
                </li>
              </ul>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <!--// rcae 홍보 -->

        <!--  board -->
        <div class="publicity second-section">
          <div class="area">
            <div class="obj publicity2">
              <ul>
                <li class="notice">
                  <div class="pbox">
                    <strong>
                      <a v-on:click="goPage('noticenews')">
                        <h3> {{ $t("centernews") }}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <span>
											<ul class="ul_list_line board">
													<li v-for="newstitle in centernews"><a v-on:click="goBoardDetail(0,newstitle.no)"><p>{{$t(newstitle.title)}}</p><p>{{$t(newstitle.date)}}</p></a></li>
											</ul>
										</span>
                  </div>
                </li>
                <li class="notice">
                  <div class="pbox">
                    <strong>
                      <a v-on:click="goPage('noticeactive')" title="학술 및 홍보활동 바로가기">
                        <h3> {{ $t("centeractive") }}</h3>
                        <i>+</i>
                      </a>
                    </strong>
                    <span>
											<ul class="ul_list_line board">
													<li v-for="activetitle in activenews"><a v-on:click="goBoardDetail(1,activetitle.no)"><p>{{$t(activetitle.title)}}</p><p>{{$t(activetitle.date)}}</p></a></li>
											</ul>
										</span>
                  </div>
                </li>
              </ul>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
        <!--//  board -->
        <!-- //contents -->
      </div>
    </section>
    <!-- //container -->

  </div>
</template>
<script>
  import {EventBus} from '../js/EventBus'
  import MainSlider from './MainSlider'
  import api from '../api/api'

  export default {
    name: 'DashBoard',
    data : function () {
      return {

        perform1: [
          {title: this.$t("field_1_1_title")},
          {title: this.$t("field_1_2_title")},
          {title: this.$t("field_1_3_title")}
        ],
        perform2: [
          {title: this.$t("field_2_1_title")},
          {title: this.$t("field_2_2_detail")},
          {title: this.$t("field_2_3_detail")},
          {title: this.$t("field_2_4_detail")}
        ],
        centernews: [],
          /*[
          {title: '센터소식 최근 게시판 보여진다.1', date: '2018.08.17'},
          {title: '센터소식 최근 게시판 보여진다.2', date: '2018.08.14'},
          {title: '센터소식 최근 게시판 보여진다.3', date: '2018.08.12'}
        ]*/
        activenews: [],
          /*[
          {title: '학술 및 홍보활동 최근 게시판 보여진다.1', date: '2018.08.17'},
          {title: '학술 및 홍보활동 최근 게시판 보여진다.2', date: '2018.08.14'},
          {title: '학술 및 홍보활동 최근 게시판 보여진다.3', date: '2018.08.12'}
        ]*/
      }
    },
    components : {
      MainSlider
    },

    mounted: function () {
      console.log('## on dash board mounted ')
      api.dashboard()
        .then((response) => {
          if (response.data.status === 'success') {
            this.centernews = response.data.center_news;
            this.activenews = response.data.center_active;

          }
          else {
            //console.log('## 3 ' + JSON.stringify(response.data));
            alert('에러 : ' + response.data.message)
          }
        })

    },
    methods : {
      goPage: function(pageName, params)
      {
        console.log('## ' + JSON.stringify(params))
        EventBus.$emit('go-page-name' , pageName , params);
      },
      goBoardDetail(type, no) {
        console.log('## no: ' + no)
        this.$router.push({name: "noticedetail" , params:{type:type,contentsNo:no} })
      }
    }
    ,beforeRouteUpdate(to,from,next)
    {
      cosole.log('## r update')
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DashBoard.vue